<template>
  <div>
    <div class="lessons__status-wrap" v-if="lessonStatus">
      <div class="lessons__status-select" @click="viewStatus = !viewStatus">
        <button
          class="lessons__selected-status"
          :class="[
            {
              'lesson__status-grey': lessonStatus.color === 'grey'
            }
          ]"
        >
          <div v-if="lessonStatus.icon" class="pay-icon">
            <icon :name="lessonStatus.icon" />
          </div>
          <div
            class="lessons__selected-status_text"
            :class="[
              {
                'text-blue': lessonStatus.color === 'blue'
              }
            ]"
          >
            <span>{{ lessonStatus.name }}</span>
          </div>
          <div class="lessons__selected-vektor_icon">
            <icon name="arrow-down-icon"></icon>
          </div>
        </button>
      </div>
      <div v-if="viewStatus" class="lessons__statuses">
        <div
          class="lessons__status-select"
          v-for="stat in filterStatuses"
          :key="stat.id"
        >
          <button
            @click="selectedStatus(stat)"
            class="lessons__selected-status"
            :class="[
              {
                'lesson__status-green': stat.color === 'green'
              },
              {
                'lesson__status-grey': stat.color === 'grey'
              },
              {
                'lesson__status-yellow': stat.color === 'yellow'
              },
              {
                'lesson__status-red-with-pay': stat.color === 'red-pay'
              },
              {
                'lesson__status-blue': stat.color === 'blue'
              }
            ]"
          >
            <div class="lessons__selected-status_icon">
              <icon :name="stat.icon" />
            </div>
            <div
              class="lessons__selected-status_text"
              :class="[
                {
                  'text-blue': stat.color === 'blue'
                },
                {
                  'text-grey': stat.color === 'grey'
                }
              ]"
            >
              <span>{{ stat.name }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'SelectStatusLesson',
  props: {
    statusUpdate: {
      type: Boolean
    },
    statusSee: {
      type: Boolean
    },
    lessonStatusId: {
      type: Number
    },
    lesson_started: {
      type: Boolean
    },
    changeStatusLesson: {
      type: Object
    }
  },
  data() {
    return {
      viewStatus: false,
      statuses: [
        {
          icon: 'passed-with-pay',
          name: 'התקיים',
          id: 2,
          color: 'green'
        },
        {
          icon: '',
          name: 'מועד עבר',
          id: 4,
          color: 'yellow'
        },
        {
          icon: 'passed-with-pay',
          name: 'לא התקיים',
          id: 3,
          color: 'red-pay'
        },
        {
          icon: '',
          name: 'מתוכנן',
          id: 1,
          color: 'blue'
        },

        {
          icon: '',
          name: 'בוטל',
          id: 5,
          color: 'grey'
        }
      ],
      lessonStatus: null
    };
  },

  computed: {
    ...mapState({
      daySlot: s => s.studyCenter.dayPopupDaySlot
    }),
    filterStatuses() {
      if (this.lessonStatusId === 1 && !this.lesson_started) {
        const statuses = this.statuses.filter(el => el.id == 5);
        return statuses;
      }
      if (this.lessonStatusId === 1 && this.lesson_started) {
        const statuses = this.statuses.filter(
          el => el.id == 3 || el.id == 2 || el.id == 5
        );
        return statuses;
      }
      if (this.lessonStatusId === 4) {
        const statuses = this.statuses.filter(
          el => el.id == 3 || el.id == 2 || el.id == 5
        );
        return statuses;
      }
      if (this.lessonStatusId === 2) {
        const statuses = this.statuses.filter(
          el => el.id == 3 || el.id == 4 || el.id == 5
        );
        return statuses;
      }
      if (this.lessonStatusId === 3) {
        const statuses = this.statuses.filter(
          el => el.id == 2 || el.id == 4 || el.id == 5
        );
        return statuses;
      }
      if (this.lessonStatusId == 5 && !this.lesson_started) {
        const statuses = this.statuses.filter(el => el.id == 1);
        return statuses;
      }
      if (this.lessonStatusId == 5 && this.lesson_started) {
        const statuses = this.statuses.filter(
          el => el.id == 2 || el.id == 3 || el.id == 4
        );
        return statuses;
      } else {
        return this.statuses;
      }
    }
  },
  watch: {
    lessonStatusId(val) {
      if (val == null) {
        this.lessonStatus = null;
      }
      const status = this.statuses.find(el => el.id == val);
      setTimeout(() => {
        this.selectStatus(status);
      }, 0);
    },
    changeStatusLesson(val) {
      if (val !== null) {
        this.selectStatus(val);
      }
    }
  },
  created() {
    // this.lessonStatus = null;
    const status = this.statuses.find(el => el.id == this.lessonStatusId);
    setTimeout(() => {
      this.selectStatus(status);
    }, 0);
  },
  methods: {
    selectStatus(item) {
      this.lessonStatus = {};
      this.lessonStatus = Object.assign(item);
    },
    selectedStatus(item) {
      if (item.id !== 5) {
        this.lessonStatus = {};
        this.lessonStatus = item;
        this.$emit('lessonStatus', item.id);
      }
      if (item.id === 5) {
        this.$emit('closeLesson', item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lessons__status-wrap {
  position: relative;
}
.lesson__status-green {
  background: #29cc44;
}
.lessons__selected-vektor_icon {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  svg {
    width: 100%;
    height: 100%;
    stroke: black;
  }
}

.lesson__status-red-with-pay {
  background: #ff5040;
}
.lesson__status-red {
  background: #ff3826;
}
.lesson__status-blue {
  background: #e5f2ff;
}
.lesson__status-grey {
  background: #cfd3de;
}
.lesson__status-yellow {
  background: #ffcc33;
}

.pay-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  svg {
    width: 100%;
    height: 100%;
  }
}
.text-blue {
  color: #409fff !important;
}
.text-grey {
  color: #929baa !important;
}
.lessons__statuses {
  position: absolute;
  top: calc(100% + 8px);
  z-index: 1;
  width: 150px;
  border: 0.75px solid #ebeef5;
  box-shadow: 0px 8px 20px rgba(56, 69, 93, 0.1),
    0px 4px 9px rgba(56, 69, 93, 0.08), 0px 2px 5px rgba(56, 69, 93, 0.0596107),
    0px 1px 3px rgba(56, 69, 93, 0.05),
    0px 0.598509px 1.5px rgba(56, 69, 93, 0.0403893),
    0px 0.249053px 1px rgba(56, 69, 93, 0.03);
  background: #ffffff;
  padding: 8px;
  border-radius: 4px;
  .lessons__selected-status_text {
    flex-grow: 0;
  }
  .lessons__selected-status {
    &.lesson__status-yellow {
      .lessons__selected-status_icon {
        display: none;
      }
    }
    &.lesson__status-grey {
      .lessons__selected-status_icon {
        display: none;
      }
    }
  }
  .lessons__status-select {
    justify-content: unset;
  }
  .lessons__status-select:not(:last-child) {
    margin-bottom: 8px;
  }
}
.lessons__selected-status_text {
  font-size: 12px;
  line-height: 16px;
  color: black;
  letter-spacing: 0.01em;
  flex-grow: 1;
}
.lessons__selected-status_icon {
  width: 16px;
  height: 16px;
  display: flex;
  svg {
    width: 100%;
    height: 100%;
    stroke: black;
  }
}
.lessons__selected-status {
  height: 31px;
  border: none;
  position: relative;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  width: 130px;
}

.test_status {
  background: green;
}
</style>
